<div class="row" style="margin:10px 0px;">
  <div class="col-md-12" style="padding:0">
    <div class="panel panel-default">
      <div class="panel-default" *ngIf="!loading">
        <div class="panel-heading" (click)="isCollapsed.main = !isCollapsed.main">
          <h4 class="panel-title">
            <a role="button">
              <i *ngIf="!isCollapsed.main && item !== undefined" class="pull-left fa fa-chevron-up"></i>
              <i *ngIf="isCollapsed.main && item !== undefined" class="pull-left fa fa-chevron-down"></i>
              <span *ngIf="item == undefined && !loading">No </span>
              <span>
                                Related {{ meta.verbose_name }}
                            </span>
            </a>
            <div *ngIf="meta.permissions.write && !loading && meta.type !== undefined && item !== undefined" class="pull-right">
                            <span style="cursor: pointer;" (click)="openReverse(item)">
                                Edit {{ meta.verbose_name }}
                              <i class="fa fa-plus-circle"></i>
                            </span>
              <span style="cursor: pointer;" (click)="deleteReverse()">
                                Remove {{ meta.verbose_name }}
                <i class="fa fa-times-circle"></i>
                            </span>
            </div>
            <div *ngIf="item === undefined && !loading" class="pull-right">
              No Related {{ meta.verbose_name }}.
              <span style="cursor: pointer;" (click)="openReverse(item)"
                    *ngIf="meta.permissions.write && meta.type !== undefined">
                                Add {{ meta.verbose_name }}
                <i class="fa fa-plus-circle"></i>
                            </span>
            </div>
          </h4>
        </div>
      </div>
      <div class="panel-body" *ngIf="loading" [ngbCollapse]="!isCollapsed.main">
        <i class="fa fa-spinner fa-pulse"></i>
      </div>
      <div class="panel-body" *ngIf="item !== undefined && !loading"
           [ngbCollapse]="isCollapsed.main">
        <div class="row" *ngFor="let key of displayFields; let i=index" style="margin:unset">
          <div *ngIf="i % 3 === 0" class="row" style="width: 100%">
            <div class="col-md-2" *ngIf="meta.fields[displayFields[i]] !== undefined">
              <b>{{ meta.fields[displayFields[i]].label }}:</b>
            </div>
            <div class="col-md-2">
              <app-display-field [type]="meta.fields[displayFields[i]].type"
                                 [value]="item[displayFields[i]]"
                                 [choices]="meta.fields[displayFields[i]].choices"></app-display-field>
            </div>
            <div class="col-md-2" *ngIf="meta.fields[displayFields[i+1]] !== undefined">
              <b>{{ meta.fields[displayFields[i + 1]].label }}:</b>
            </div>
            <div class="col-md-2" *ngIf="displayFields[i+1]">
              <app-display-field [type]="meta.fields[displayFields[i+1]].type"
                                 [value]="item[displayFields[i+1]]"
                                 [choices]="meta.fields[displayFields[i+1]].choices"></app-display-field>
            </div>
            <div class="col-md-2" *ngIf="meta.fields[displayFields[i+2]] !== undefined">
              <b>{{ meta.fields[displayFields[i + 2]].label }}:</b>
            </div>
            <div class="col-md-2" *ngIf="displayFields[i+2]">
              <app-display-field [type]="meta.fields[displayFields[i+2]].type"
                                 [value]="item[displayFields[i+2]]"
                                 [choices]="meta.fields[displayFields[i+2]].choices"></app-display-field>
            </div>
          </div>
        </div>
        <div class="row" style="padding: 0 15px;" *ngFor="let itemKey of meta.subItems">
          <app-nested-inline style="width: 100%" [meta]="meta.fields[itemKey]"
                             [items]="item[itemKey]" [foreignKey]="item.globalid"></app-nested-inline>
        </div>
      </div>
    </div>
  </div>
</div>
